import { render, staticRenderFns } from "./NewRealEstateOfAssetEdit.vue?vue&type=template&id=ac8ef16a&scoped=true&"
import script from "./NewRealEstateOfAssetEdit.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateOfAssetEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateOfAssetEdit.vue?vue&type=style&index=0&id=ac8ef16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8ef16a",
  null
  
)

export default component.exports